import React from "react";

import { useFormikContext } from "formik";

import { EngineEnum } from "../../../../enums/engine";
import { ArticleTypeEnum } from "../../../../enums/template";
import { Template } from "../../../../models";
import { getEngineName, getEngineSVG } from "../../../../utils";

import EnginePrimaryNote from "../../../../components/common/EnginePrimaryNote";
import SelectV2 from "../../../../components/form/CustomSelect";
import TemplateContainer from "../common/TemplateContainer";

export const engineOptions = [
  {
    value: EngineEnum.CLAUDE_SONNET_4_5,
    label: getEngineName(EngineEnum.CLAUDE_SONNET_4_5),
    icon: getEngineSVG(EngineEnum.CLAUDE_SONNET_4_5),
    description: "",
  },
  {
    value: EngineEnum.CLAUDE_3_OPUS_20240229,
    label: getEngineName(EngineEnum.CLAUDE_3_OPUS_20240229),
    icon: getEngineSVG(EngineEnum.CLAUDE_3_OPUS_20240229),
    description: "",
  },
  {
    value: EngineEnum.CLAUDE_3_5_SONNET_20240620,
    label: getEngineName(EngineEnum.CLAUDE_3_5_SONNET_20240620),
    icon: getEngineSVG(EngineEnum.CLAUDE_3_5_SONNET_20240620),
    description: "",
  },
  {
    value: EngineEnum.CLAUDE_3_5_SONNET_20241022,
    label: getEngineName(EngineEnum.CLAUDE_3_5_SONNET_20241022),
    icon: getEngineSVG(EngineEnum.CLAUDE_3_5_SONNET_20241022),
    description: "",
  },
  {
    value: EngineEnum.CLAUDE_3_5_HAIKU_20241022,
    label: getEngineName(EngineEnum.CLAUDE_3_5_HAIKU_20241022),
    icon: getEngineSVG(EngineEnum.CLAUDE_3_5_HAIKU_20241022),
    description: "",
  },
  {
    value: EngineEnum.CLAUDE_3_7_SONNET_20250219,
    label: getEngineName(EngineEnum.CLAUDE_3_7_SONNET_20250219),
    icon: getEngineSVG(EngineEnum.CLAUDE_3_7_SONNET_20250219),
    description: "",
  },
  {
    value: EngineEnum.GPT_4_TURBO_2024_04_09,
    label: getEngineName(EngineEnum.GPT_4_TURBO_2024_04_09),
    icon: getEngineSVG(EngineEnum.GPT_4_TURBO_2024_04_09),
    description: "",
  },
  {
    value: EngineEnum.GPT_4O_MINI_2024_07_18,
    label: getEngineName(EngineEnum.GPT_4O_MINI_2024_07_18),
    icon: getEngineSVG(EngineEnum.GPT_4O_MINI_2024_07_18),
    description: "",
  },
  {
    value: EngineEnum.O3_MINI_2025_01_31,
    label: getEngineName(EngineEnum.O3_MINI_2025_01_31),
    icon: getEngineSVG(EngineEnum.O3_MINI_2025_01_31),
    description: "",
  },
  {
    value: EngineEnum.GEMINI_1_5_PRO,
    label: getEngineName(EngineEnum.GEMINI_1_5_PRO),
    icon: getEngineSVG(EngineEnum.GEMINI_1_5_PRO),
    description: "",
  },
  {
    value: EngineEnum.GPT_5_2025_08_07,
    label: getEngineName(EngineEnum.GPT_5_2025_08_07),
    icon: getEngineSVG(EngineEnum.GPT_5_2025_08_07),
    description: "",
  },
  {
    value: EngineEnum.GPT_5_MINI_2025_08_07,
    label: getEngineName(EngineEnum.GPT_5_MINI_2025_08_07),
    icon: getEngineSVG(EngineEnum.GPT_5_MINI_2025_08_07),
    description: "",
  },
  {
    value: EngineEnum.GPT_5_NANO_2025_08_07,
    label: getEngineName(EngineEnum.GPT_5_NANO_2025_08_07),
    icon: getEngineSVG(EngineEnum.GPT_5_NANO_2025_08_07),
    description: "",
  },
];

const Engine = () => {
  let defaultEngine = EngineEnum.GPT_5_2025_08_07;
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();

  if (
    [
      ArticleTypeEnum.SHORT_SUMMARY,
      ArticleTypeEnum.NEWS,
      ArticleTypeEnum.OPINION,
      ArticleTypeEnum.SMART_BREVITY,
    ].includes(values?.articleTypeId!)
  ) {
    defaultEngine = EngineEnum.GPT_5_2025_08_07; // keeping same as default but it can change
  }

  const selectedEngine = engineOptions.find(
    (option) => option.value === values?.engineId
  );

  return (
    <div className="animate-fadeIn">
      <TemplateContainer isSuperUserFeature>
        <SelectV2
          label="Template Engine"
          placeholder="-"
          options={engineOptions}
          selected={selectedEngine}
          setSelected={(option) => {
            setFieldValue("engineId", option?.value ?? null);
          }}
          maxMenuHeight={150}
        />
        {!selectedEngine && (
          <EnginePrimaryNote
            engineName={getEngineName(defaultEngine)}
            icon={getEngineSVG(defaultEngine)}
          />
        )}
      </TemplateContainer>
    </div>
  );
};

export default Engine;
